import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import PermissionsAdd from './../../elements/permissions/widget/permissions_add';

class Permissions extends Component {
	render(){
		return(
			<PermissionsList {...this.props}/>
		);
	}

	componentWillMount(){
		const { permissions } = this.props;
		this.props.permissionsShow(permissions.pages.current, permissions.filters);
	}
}

export class PermissionsList extends Component{
	render() {
		const { permissions } = this.props;
		let pu = _.find(permissions.permissions, (o) => {return o==='Update'});
		let pd = _.find(permissions.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{permissions.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Nombre</th>
							<th>Nombre de Permiso</th>
						</tr>
						</thead>
						<tbody>
						{_.map(permissions.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:10+'%'}}>
										<div className="actions">
											{pu ? <NavLink to={`/permisos/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{pd ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td><strong>{row.name}</strong></td>
									<td>{row.display}</td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{permissions.pages.total>20 &&
				<InmPagination key="concepts-pages"
				               current={permissions.pages.current}
				               total={permissions.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el permiso "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.deletePermission(id)
		})
	}

	_handlePageChange(value) {
		this.props.permissionsShow(value);
	}
}

//export default BaseLayout(Permissions, {title: 'Administrar permisos', subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/permisos/crear', name: 'Agregar permiso'}}});
export default BaseLayout(Permissions, {
	title: 'Administrar permisos',
	subnav: {
		icon: 'fa-user-secret',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <PermissionsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/permissions/index.jsx